module.exports = __webpack_public_path__ + "img/2x.f82e448.jpg";